// DS — pigułka statusu: SŁOWO niesie stan, kropka = currentColor (artboard 01, G3-25).
// Tony: ok · info · warn · danger · muted. `live` = pierścień na kropce, wyłącznie
// gdy odtwarzacz gra (motion.css: keyframe `live`).

import type { ReactNode } from 'react'

export type StatusTone = 'ok' | 'info' | 'warn' | 'danger' | 'muted'
type LegacyTone = 'published' | 'scheduled' | 'live' | 'draft'

const TONE: Record<StatusTone | LegacyTone, StatusTone> = {
  ok: 'ok', info: 'info', warn: 'warn', danger: 'danger', muted: 'muted',
  published: 'ok', scheduled: 'warn', live: 'ok', draft: 'muted',
}

export interface StatusPillProps {
  children?: ReactNode
  tone?: StatusTone | LegacyTone
  /** Pierścień „na żywo” — tylko gdy coś naprawdę gra. */
  live?: boolean
  className?: string
  'data-testid'?: string
  /** Wartość enum dla testów i skanów (np. status serii). */
  'data-status'?: string
}

export function StatusPill({ children, tone = 'muted', live, className = '', ...rest }: StatusPillProps) {
  const t = TONE[tone] ?? 'muted'
  return (
    <span className={['status-pill', `sp-${t}`, live && 'is-live', className].filter(Boolean).join(' ')} data-testid={rest['data-testid']} data-status={rest['data-status']}>
      {children}
    </span>
  )
}

export default StatusPill
